import { createSlice } from "@reduxjs/toolkit";
import { AUTH_TOKEN, DEVICE_IDENTIFIER } from "../../data/local-storage-constants";
import { setLocalStorage } from "../../utils";
import { userNormalLogout, supportLogout } from "../actions";

export interface LoginState {
  branchvos: [];
  businessData: {};
  token: {};
  userData: {};
  userDetails: {};
}

const initialState: LoginState = {
  branchvos: [],
  businessData: {},
  token: {},
  userData: {},
  userDetails: {}
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    validateUserData: (state, actions) => {},
    saveLoginData: (state, action) => {
      setLocalStorage(AUTH_TOKEN, action.payload.token.tokenId);
      setLocalStorage(
        DEVICE_IDENTIFIER,
        action.payload.token.deviceIdentifier
      );

      state = { ...action.payload };
    },
    userLogout: (state, action) => {},
    getUserDetails: (state, action) => {},
    saveUserDetails: (state, action) => {
      state.userDetails = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const { validateUserData, saveLoginData, userLogout, getUserDetails, saveUserDetails } =
  loginSlice.actions;
export default loginSlice.reducer;
